<template>
  <v-expand-transition>
    <v-card v-if="selectedUser" flat>      
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <h5>Notifieringar</h5>
        <p class="mt-n1">
          <b>Notifieringarna gäller ärenden och information i de regioner som användaren har behörighet till.</b>
        </p>

        <v-row>
          <v-col cols="12">
            <v-checkbox
              class="mt-n4"
              label="Får notifieringar om nya lärlingsanmälningar."
              v-model="selectedUser.allowApplicationNotifications"
            />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              class="mt-n9"
              label="Får notifieringar om nya företag."
              v-model="selectedUser.allowCompanyNotifications"
            />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              class="mt-n9"
              label="Får notifieringar om nya ansökningar om yrkesbevis."
              v-model="selectedUser.allowTradeCertificateNotifications"
            />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              class="mt-n9"
              label="Får notifieringar om nya maskinslag."
              v-model="selectedUser.allowMachineQualificationNotifications"
            />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              class="mt-n9"
              label="Får notifieringar om nya ansökningar om handledardispens."
              v-model="selectedUser.allowDistanceOrderNotifications"
            />
          </v-col>
        </v-row>

        <h5>Meddelanden</h5>
        <v-row cols="12">
          <v-col cols="12">
            <v-checkbox
              :disabled="(selectedUser.userrole && !selectedUser.userrole.isRegionary)"
              class="mt-n5"
              label="Tar emot e-postmeddelanden som skickas till de regioner som användaren har behörighet till."
              v-model="selectedUser.allowRegionMessages"
            />
            <div class="ml-8 mt-n4 caption grey-text">Den här inställningen gör användarens e-postadress används som en publik mottagaradress för gemensam e-post till de regioner som användaren har behörighet till. E-post som skickas till en region på detta sätt ska betraktas som om den skickats till en gemensam inkorg för regionen och behöver hanteras av en av regionen utsedd person.</div>
          </v-col>
        </v-row>

        <h5>E-post/SMS</h5>
        <v-row cols="12">
          <v-col cols="12">
            <v-checkbox
              class="mt-n4"
              label="Jag vill att meddelanden och notifieringar skall skickas via e-post."
              v-model="selectedUser.allowEmail"
            />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              class="mt-n9"
              label="Jag vill att meddelanden och notifieringar skall skickas via SMS."
              v-model="selectedUser.allowSMS"
            />
            <div class="ml-8 mt-n4 caption grey-text">OBSERVERA: Om varken E-post eller SMS är valt kommer inga meddelanden eller notifieringar att skickas.</div>
          </v-col>
        </v-row>

        <v-card-actions class="justify-space-between no-margins mt-6">
          <v-btn class="icon" @click="$emit('saveuser', selectedUser)">
            <v-icon>$sl-check</v-icon>Spara
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-expand-transition>
</template>

<script>
import AddressBox from '@/components/AddressBox.vue'
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {RulesMixin} from '@/components/mixins'
export default {
  data() {
    return {
      valid: true,
      lazy: false
    }
  },
  created() {
    console.log('user notifications -- created')
  },
  computed: {
    ...mapGetters('user', ['selectedUser'])
  }
}
</script>

<style lang="scss" scoped>
</style>